export default __webpack_public_path__ + "static/unsplash-26c539ef764ad9d2ac499b1b329ad774.png";